import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { Button } from './Button/index.js';
import { i18n } from '../i18n/translate.js';
import { FAIcon } from './fa-icon/component.js';
import { pickDataAttributes } from '../utils/pickDataAttributes.js';
var ModalHeader = /*#__PURE__*/function (_Component) {
  function ModalHeader() {
    _classCallCheck(this, ModalHeader);
    return _callSuper(this, ModalHeader, arguments);
  }
  _inherits(ModalHeader, _Component);
  return _createClass(ModalHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        canClickOff = _this$props.canClickOff,
        onCancel = _this$props.onCancel,
        title = _this$props.title,
        titleId = _this$props.titleId,
        closeButton = _this$props.closeButton,
        closeButtonIcon = _this$props.closeButtonIcon,
        description = _this$props.description,
        titleComponentType = _this$props.titleComponentType,
        descriptionComponentClass = _this$props.descriptionComponentClass,
        DescriptionComponent = _this$props.descriptionComponentType;
      var dataAttributes = pickDataAttributes(this.props);
      return /*#__PURE__*/React.createElement(Modal.Header, {
        className: className,
        closeButton: false,
        onHide: onCancel
      }, canClickOff && closeButton && /*#__PURE__*/React.createElement(Button, _extends({}, dataAttributes, {
        "aria-label": i18n.t('Close'),
        className: "pull-right close-link",
        "data-action": "close-modal",
        onClick: onCancel,
        style: "default"
      }), /*#__PURE__*/React.createElement(FAIcon, {
        icon: closeButtonIcon
      })), title && /*#__PURE__*/React.createElement(Modal.Title, {
        id: titleId,
        as: titleComponentType,
        "data-action": "modal-title"
      }, title), description && /*#__PURE__*/React.createElement(DescriptionComponent, {
        className: "".concat(descriptionComponentClass, " modal-description")
      }, description));
    }
  }]);
}(Component);
_defineProperty(ModalHeader, "propTypes", {
  canClickOff: PropTypes.bool,
  className: PropTypes.string,
  closeButton: PropTypes.bool,
  closeButtonIcon: PropTypes.string,
  description: PropTypes.string,
  descriptionComponentClass: PropTypes.string,
  descriptionComponentType: PropTypes.elementType,
  onCancel: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  titleComponentType: PropTypes.elementType,
  titleId: PropTypes.string
});
_defineProperty(ModalHeader, "defaultProps", {
  className: '',
  closeButton: true,
  closeButtonIcon: 'xmark',
  description: '',
  descriptionComponentClass: 'p2',
  descriptionComponentType: 'p',
  titleComponentType: 'h2'
});
ModalHeader.displayName = "ModalHeader";
export { ModalHeader };